module.exports = __webpack_public_path__ + "static/media/highlights (3).9edb5dd4.jpg";